export default "__VITE_ASSET__C19K4V18__"